'use client';

import { useSelectedLayoutSegments } from 'next/navigation';

export const useIsSegmentInSelectedLayoutSegments = (layoutSegment: string) => {
  const selectedLayoutSegments = useSelectedLayoutSegments();
  return selectedLayoutSegments.includes(layoutSegment);
};
